export const useSnackbarStore = defineStore('snackbars', {
  state: () => ({
    snackbars: {}
  }),

  actions: {
    async updateSnackbar (payload) {
      const _id = payload.id
      this.snackbars[_id] = payload

      await wait(100) 

      // for fade in animation
      this.snackbars[_id].isShow = true

      // if the snackbar doesn't have close button, it will be removed after 5 seconds
      if (!payload.hasCloseButton) {
        await wait(5000)
        this.removeSnackbar(_id)
      }
    },

    async removeSnackbar (_id) {
      // for fade out animation
      this.snackbars[_id].isShow = false
      
      await wait(1000) 

      delete this.snackbars[_id]
    }
  }
})
